import "./sidebar.css";
import {
    LineStyle,
    PermIdentity,
    Add,
    StoreOutlined,
    QueryBuilder,
    Assessment,
    Flag,
    ShoppingCart,
    ArrowBack,
    TrendingUp,
    ExitToApp,
    ShoppingCartOutlined,
    Build,
    Lock,
    Description,
} from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/userRedux";
import { useState, useEffect } from "react";

export default function Sidebar() {
    const dispatch = useDispatch();
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const width = window.innerWidth;
        return width > 768 && width <= 1024;
    });
    const location = useLocation();

    // Keep sidebar collapsed on tablet, expanded on mobile/desktop
    useEffect(() => {
        const syncCollapseWithWidth = () => {
            const width = window.innerWidth;
            if (width <= 768) {
                setIsCollapsed(false);
            } else if (width <= 1024) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        syncCollapseWithWidth();
        window.addEventListener("resize", syncCollapseWithWidth);
        return () => window.removeEventListener("resize", syncCollapseWithWidth);
    }, []);

    // Collapse only on tablet widths after a navigation
    const handleLinkClick = () => {
        const width = window.innerWidth;
        const isTablet = width > 768 && width <= 1024;
        if (isTablet) {
            setIsCollapsed(true);
        }
    };

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );

    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const marketing = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "marketing"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const hq = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "HQ"
            : null
    );

    const salesperson = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "salesperson"
            : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);

    const handleClick = () => {
        dispatch(logout());
        window.location.href = "/";
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

  return (
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            <div className="sidebarWrapper">
                {/* Header */}
                <div className="sidebarHeader">
                    <div className="sidebarLogo flex justify-center w-full">
          {!isCollapsed && (
                            <div className="flex justify-center">
                                <img 
                                    src="https://venti-fans.com/wp-content/uploads/2026/02/klerp-logo-transparent-1.png"
                                    alt="KLERPTECH Logo"
                                    style={{
                                        width: "100%",
                                        maxWidth: "120px",
                                        height: "auto"
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <button className="sidebarCollapseBtn" onClick={toggleSidebar}>
                        <ArrowBack className={isCollapsed ? 'rotated' : ''} />
          </button>
        </div>

                {/* User Info */}
                <div className="sidebarUser">
                    <div className="sidebarUserAvatar">
                        {currentUser?.name?.charAt(0) || 'I'}
      </div>
      {!isCollapsed && (
                        <div className="sidebarUserInfo">
                            <div className="sidebarUserName">
                                {currentUser?.name || 'InHome Solar'}
            </div>
                            <div className="sidebarUserRole">
                                {superadmin ? 'Superadmin' : admin ? 'Admin' : currentUser?.type || 'User'}
          </div>
        </div>
      )}
                </div>

                <div className="sidebarMenu">
                    <ul className="sidebarList">
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/" ? "active" : ""}`}>
                                <LineStyle className="sidebarIcon" />
                                {!isCollapsed && "Home"}
                            </li>
                        </Link>
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/pos"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/pos" ? "active" : ""}`}>
                                <TrendingUp className="sidebarIcon" />
                                {!isCollapsed && "POS"}
                            </li>
                        </Link>
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/orders"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/orders" ? "active" : ""}`}>
                                <ShoppingCart className="sidebarIcon" />
                                {!isCollapsed && "Orders"}
                            </li>
                        </Link>
                        {(superadmin || hq) && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/terms"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname.startsWith("/terms") ? "active" : ""}`}>
                                    <Description className="sidebarIcon" />
                                    {!isCollapsed && "Terms"}
                                </li>
                            </Link>
                        )}
                        {(superadmin || hq) && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/warrantyrequests"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/warrantyrequests" ? "active" : ""}`}>
                                    <Build className="sidebarIcon" />
                                    {!isCollapsed && "Warranty Requests"}
                                </li>
                            </Link>
                        )}
                        {!salesperson && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/history"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/history" ? "active" : ""}`}>
                                    <ShoppingCartOutlined className="sidebarIcon" />
                                    {!isCollapsed && "Customer History"}
                                </li>
                            </Link>
                        )}
                    </ul>
                </div>

                <div className="sidebarMenu">
                    <ul className="sidebarList">
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/users"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/users" ? "active" : ""}`}>
                                <PermIdentity className="sidebarIcon" />
                                {!isCollapsed && "Users"}
                            </li>
                        </Link>
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/newuser"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/newuser" ? "active" : ""}`}>
                                <Add className="sidebarIcon" />
                                {!isCollapsed && "New User"}
                            </li>
                        </Link>
                        {!salesperson && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/newstaff"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/newstaff" ? "active" : ""}`}>
                                    <Add className="sidebarIcon" />
                                    {!isCollapsed && "New Staff"}
                                </li>
                            </Link>
                        )}
                        {(superadmin || hq) && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/outlets"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/outlets" ? "active" : ""}`}>
                                    <StoreOutlined className="sidebarIcon" />
                                    {!isCollapsed && "Admin Accounts"}
                                </li>
                            </Link>
                        )}
                    </ul>
              </div>

                <div className="sidebarMenu">
                    <ul className="sidebarList">
                        {!salesperson && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/salesreport"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/salesreport" ? "active" : ""}`}>
                                    <Flag className="sidebarIcon" />
                                    {!isCollapsed && "Outlet Report"}
                                </li>
                            </Link>
                        )}
                        {(superadmin || hq) && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                to="/report"
                                className="link"
                                onClick={handleLinkClick}
                            >
                                <li className={`sidebarListItem ${location.pathname === "/report" ? "active" : ""}`}>
                                    <QueryBuilder className="sidebarIcon" />
                                    {!isCollapsed && "Monthly Report"}
                                </li>
                            </Link>
                        )}
                    </ul>
          </div>

                {/* Change Password and Logout at bottom */}
                <div className="sidebarMenu sidebarLogout">
                    <ul className="sidebarList">
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                            }}
                            to="/changepassword"
                            className="link"
                            onClick={handleLinkClick}
                        >
                            <li className={`sidebarListItem ${location.pathname === "/changepassword" ? "active" : ""}`}>
                                <Lock className="sidebarIcon" />
                                {!isCollapsed && "Change Password"}
                            </li>
                        </Link>
                        <li className="sidebarListItem" onClick={handleClick}>
                            <ExitToApp className="sidebarIcon" />
                            {!isCollapsed && "Logout"}
                        </li>
                    </ul>
                </div>
            </div>
    </div>
  );
}
